import { Handle, Position } from "@xyflow/react";
import { Input } from "antd";
import { MessageOutlined } from "@ant-design/icons";

const TextNode = ({ data, selected }) => {
  const onChange = (value) => data.onChange?.({ ...data, message: value });

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#10b981" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    }}>
      <Handle type="target" position={Position.Left} style={{ background: "#10b981" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <MessageOutlined style={{ color: "#10b981", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Text Message</strong>
      </div>

      <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>
        Message <span style={{ color: "#9ca3af" }}>{(data.message || "").length}/1098</span>
      </label>
      <Input.TextArea
        value={data.message || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        maxLength={1098}
        placeholder="Enter message text..."
        style={{ fontSize: 12 }}
      />

      <Handle type="source" position={Position.Right} style={{ background: "#10b981" }} />
    </div>
  );
};

export default TextNode;
